import { Instagram, Mail, MapPin, Phone, MessageCircle, Clock } from "lucide-react";
import { useSiteSettings } from "@/context/SiteSettingsContext";

export default function Footer() {
  const { logo, contact_phone, contact_whatsapp, contact_hours } = useSiteSettings();
  const waNumber = (contact_whatsapp || "+919152763208").replace(/\D/g, "");
  const waLink = `https://wa.me/${waNumber}?text=Hi%20OUTLAW-D%2C%20I%20need%20help%20with%20my%20order`;
  const telLink = `tel:${(contact_phone || "+91 91527 63208").replace(/\s/g, "")}`;

  return (
    <footer className="bg-black text-white mt-24 border-t-4 border-[#D4FF00]" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-6 py-16 grid md:grid-cols-4 gap-10">
        <div>
          {logo && <img src={logo} alt="OUTLAW-D" className="h-16 w-16 rounded-full border-2 border-[#D4FF00] mb-3" />}
          <h3 className="font-display text-4xl text-[#D4FF00]">OUTLAW-D</h3>
          <p className="mt-4 text-sm font-mono-b text-white/70">Custom streetwear + curated thrift. Made in India. Sold to the world.</p>
        </div>
        <div>
          <h4 className="font-display text-xl mb-3">SHOP</h4>
          <ul className="space-y-2 text-sm font-mono-b text-white/80">
            <li>Jackets</li><li>Tees</li><li>Jeans</li><li>Tote Bags</li><li>Thrifted</li>
          </ul>
        </div>
        <div>
          <h4 className="font-display text-xl mb-3">COMPANY</h4>
          <ul className="space-y-2 text-sm font-mono-b text-white/80">
            <li>Sell Your Fits</li><li>Shipping</li><li>Returns</li><li>Contact</li>
          </ul>
        </div>
        <div data-testid="footer-contact">
          <h4 className="font-display text-xl mb-3 text-[#D4FF00]">CUSTOMER SUPPORT</h4>
          <ul className="space-y-3 text-sm font-mono-b text-white/90">
            <li className="flex items-center gap-2">
              <Phone className="w-4 h-4 text-[#D4FF00]" />
              <a href={telLink} data-testid="footer-phone" className="hover:underline">{contact_phone}</a>
            </li>
            <li className="flex items-center gap-2">
              <MessageCircle className="w-4 h-4 text-[#D4FF00]" />
              <a href={waLink} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="hover:underline">WhatsApp Support</a>
            </li>
            <li className="flex items-center gap-2"><Clock className="w-4 h-4 text-[#D4FF00]" />{contact_hours}</li>
            <li className="text-xs text-white/60 mt-2">For order support, please WhatsApp us or call during business hours.</li>
            <li className="flex items-center gap-2 pt-2 border-t border-white/10 mt-3"><Mail className="w-4 h-4" />hello@outlawd.in</li>
            <li className="flex items-center gap-2"><Instagram className="w-4 h-4" />@outlawd.in</li>
            <li className="flex items-center gap-2"><MapPin className="w-4 h-4" />Made in India</li>
          </ul>
        </div>
      </div>
      <div className="border-t-2 border-[#D4FF00] py-4 text-center font-mono-b text-xs text-white/60">
        © 2026 OUTLAW-D // ALL RIGHTS RESERVED // outlawd.in
      </div>
    </footer>
  );
}
